const GLOBAL: any = window;
export default GLOBAL;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/util/global.ts